import type { NewsItem } from '../types/content'

export const news: NewsItem[] = [
  {
    id: 'tdf-2026',
    category: 'Sécurité',
    date: '8 septembre 2026',
    title: 'Tour de France 2026 : des consignes à respecter',
    excerpt:
      "Le 113e Tour de France se déroule du 4 au 26 juillet, sur 21 étapes. L'épreuve s'accompagne d'une activité aérienne intense : prises de vues, hélicoptères de coordination, transport des organisateurs. Informez-vous avant chaque étape des restrictions de survol publiées par NOTAM ou SUP AIP.",
  },
  {
    id: 'chaleurs',
    category: 'Sécurité',
    date: '4 septembre 2026',
    title: 'Vigilance : fortes chaleurs',
    excerpt:
      "Densité de l'air réduite, distances de décollage allongées, performances moteur dégradées. Recalculez vos marges et privilégiez les créneaux du matin.",
  },
  {
    id: 'festi-ulm',
    category: 'Événement',
    date: '1er septembre 2026',
    title: "Questionnaire FESTI'ULM : donnez votre avis",
    excerpt:
      "À l'occasion du Festi'ULM, la Fédération organise une table ronde sur les évolutions à venir pour l'ULM. Un questionnaire est ouvert à tous les licenciés pour préparer les échanges.",
  },
  {
    id: 'championnat',
    category: 'Sport',
    date: '26 août 2026',
    title: 'Championnat de France de précision : les résultats',
    excerpt:
      'Trois jours de navigation et d’atterrissages de précision. Retrouvez le classement complet des six classes et les qualifiés pour la sélection internationale.',
  },
]
